module.exports = __webpack_public_path__ + "img/icon-ticket-paidout.71dbb610.svg";